import { AbstractControl, ValidationErrors } from '@angular/forms'

/**
 * Rejects empty or whitespace-only SMS bodies
 * @param control Abstract control
 * @returns error or null
 */
export function SmsMessageRequiredValidator(control: AbstractControl): ValidationErrors | null {
  return String(control.value ?? '').trim() ? null : { required: true }
}
